import React, {FC, Fragment, useState} from 'react';
import './style.scss';
import MixCard from "../MixCard";
import MixTotal from "../MixTotal";
import BaseButton from "../../form/Button";
import activeLike from "../../../assets/img/mix-week/like__active.svg";
import nonLike from "../../../assets/img/mix-week/like__non-active.svg";
import MixPageHeader from "./MixPageHeader";
import {IMix, IMixTobaccos, IMixTobaccoAmount} from "../../../constants/types";

interface IMixPage {
    mix: IMix,
    handleLikeButton: any,
    /*    favoriteMixes?: Array<IMix>,*/
    goToUrl?: string
}

const MixPage: FC<IMixPage> = ({mix, handleLikeButton, goToUrl}) => {

    const [isLikedLocal, setIsLikedLocal] = useState<boolean>(mix.isLiked);
    const valuesTobacco = mix.tobaccoAmount.map((item: IMixTobaccoAmount) => item.amount);
    const [values, setValues] = useState(valuesTobacco);

    const clickHandler = (id: number, isMixLiked: boolean) => {
        setIsLikedLocal(!isLikedLocal);
        handleLikeButton(id, isMixLiked);
    };
    return (
        <Fragment>
            <MixPageHeader
                mix={mix}
                goToUrl={goToUrl}
            />
            <div className="mix-week-page">
                <div className="mix-week-page__container">
                    <div className="mix-week-page__title">
                        {mix.name}
                    </div>
                    <div className="mix-week-page__cards">
                        {
                            mix.tobaccos.map((item: IMixTobaccos, index: number) => {
                                return (
                                    <MixCard
                                        id={index}
                                        key={item.id}
                                        imageUrl={item.imageUrl}
                                        brandTobacco={item.brandName}
                                        nameTobacco={item.name}
                                        amountTobacco={values[index]}
                                        setValues={setValues}
                                        values={values}
                                    />
                                )
                            })
                        }
                    </div>
                    <div className="mix-week-page__total-container">
                        <MixTotal
                            mixTobaccos={mix.tobaccos}
                        />
                    </div>
                    <div className="mix-week-page__like">
                        <div className="mix-week-page__like-title">
                            {
                                isLikedLocal
                                    ? 'Твое мнение учтено!'
                                    : 'Понравился микс?'
                            }
                        </div>
                        <div className="mix-week-page__like-button">
                            <BaseButton
                                onClick={() => clickHandler(mix.id, isLikedLocal)}
                                isButtonCircle
                                isLikeButton
                                isFullSize
                            >
                                <img className="mix-week-page__like-photo"
                                     src={
                                         isLikedLocal
                                             ? activeLike
                                             : nonLike
                                     }
                                     alt="like"
                                />
                            </BaseButton>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
};

export default MixPage;
